import React from 'react';
import Icon from 'screens/shared/icon';
import { getLanColor, _t } from 'utils';
import Cards from 'screens/shared/cards-layout';
import Card from 'screens/shared/card';

export default ({ nics = [], history = {} }) => {
  const onNICClick = (nic) => {
    const { href = '' } = nic;
    history.push(`/nic?nicUrl=${href}`);
  };

  return (
    <Cards
      title="NICs"
      type="nic"
      isAdd={false}
      isFilter={false}
    >

      {nics.map((nic) => {
        const { id = '', properties = {} } = nic;
        const { ips = [], lan = '' } = properties;
        const [ip = ''] = ips;
        const ipsLength = ips.length - 1;
        return (
          <Card key={id} onClick={() => onNICClick(nic)}>
            <div className="cards-nic-left" style={{ backgroundColor: getLanColor(lan) }}>
              <div className="cards-nic-left-logo">
                <Icon name="ethernet" />
              </div>
            </div>

            <div className="cards-nic-right">
              <span className="cards-nic-right-title">{`LAN ${lan}`}</span>
              <div className="cards-nic-right-props">
                {!!ip && (<span className="cards-nic-right-props-ip">{ip}</span>)}
                {ipsLength > 0 && (
                  <span className="cards-nic-right-props-ip-more">{`+ ${ipsLength} ${_t('More')}`}</span>
                )}
              </div>
            </div>
          </Card>
        );
      })}

    </Cards>
  );
};
